export function SearchLight(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="none" stroke="currentColor">
        <circle cx="11" cy="11" r="6"></circle>
        <path strokeLinecap="round" d="m20 20l-3-3"></path>
      </g>
    </svg>
  )
}
